export default __webpack_public_path__ + "static/media/Deli_Check.20129103.svg";